import React, { useState } from 'react';
import { AddFormElements, CheckBoxParam, ComboBoxParam, NumberParam, SonForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { DateRangeParam, TimeRangeParam } from '../../../_lib/Form2/types/DateRangeParam';
import { Hint } from '../../../_lib/components/Hint';
import { TicketAccordion, TicketsByDate } from './TicketAccordion';
import { TicketAddModal } from './TicketAddModal';

export type TicketBookingForm = SonForm<
  | DateRangeParam<'daterange'>
  | TimeRangeParam<'timerange'>
  | CheckBoxParam<'onMondays'>
  | CheckBoxParam<'onTuesdays'>
  | CheckBoxParam<'onWednesdays'>
  | CheckBoxParam<'onThursdays'>
  | CheckBoxParam<'onFridays'>
  | CheckBoxParam<'onSaturdays'>
  | CheckBoxParam<'onSundays'>
  | NumberParam<'durationMinutes'>
  | NumberParam<'parallelTickets'>
  | ComboBoxParam<'supplierUserId'>
  | ComboBoxParam<'firstToBeNotifiedUserId'>
  | ComboBoxParam<'secondToBeNotifiedUserId'>
>;

export type TicketBookingEditProps = {
  form: TicketBookingForm;
  ticketsOfDate: TicketsByDate[];
};

export function TicketBookingEditPartial({ form, ticketsOfDate }: TicketBookingEditProps) {
  const { t } = useSonTranslation('TicketBooking');
  const [activeModal, setActiveModal] = useState<boolean>(false);

  const closeModal = () => setActiveModal(false);
  const showModal = () => setActiveModal(true);

  return (
    <>
      {ticketsOfDate?.length > 0 && (
        <div className="ticket-booking__ticket-list">
          <TicketAccordion ticketsOfDate={ticketsOfDate} />
        </div>
      )}
      <div className="ticket-booking__container">
        {(!ticketsOfDate || ticketsOfDate?.length === 0) && (
          <>
            <div className="ticket-booking__description">
              <Hint message={t('edit.description.text')} />
              <ContentParagraph>{t('edit.description.additionalText')}</ContentParagraph>
            </div>
            <div className="ticket-booking__no-tickets">
              <ContentParagraph>{t('edit.noTickets')}</ContentParagraph>
            </div>
          </>
        )}
        <AddFormElements name={t('edit.addTickets')} onClick={showModal} />
      </div>
      {activeModal && <TicketAddModal closeModal={closeModal} form={form} />}
    </>
  );
}
